import React from 'react';
import { Badge } from '@rezi/ui/badge';
import { Card } from '@rezi/ui/card';
import type { DocEntry } from '../docsRegistry';

const formatDate = (value: string) => {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }
  return parsed.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
};

const MetadataPanel = ({ doc }: { doc: DocEntry }) => {
  const hasChangelog = doc.changelog?.length > 0;

  return (
    <Card className="sticky top-24 flex flex-col gap-4">
      <div className="text-sm font-semibold tracking-[0.18em] text-gray-400 uppercase">
        Metadata
      </div>
      <div className="flex flex-col gap-3 text-sm text-gray-700">
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs font-semibold tracking-[0.14em] text-gray-400 uppercase">
            Owner
          </span>
          <span className="text-text font-semibold">{doc.owner}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs font-semibold tracking-[0.14em] text-gray-400 uppercase">
            Status
          </span>
          <span>{doc.status}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs font-semibold tracking-[0.14em] text-gray-400 uppercase">
            Last reviewed
          </span>
          <span>{formatDate(doc.lastReviewed)}</span>
        </div>
        <div className="flex items-center justify-between gap-4">
          <span className="text-xs font-semibold tracking-[0.14em] text-gray-400 uppercase">
            Visibility
          </span>
          <span>{doc.visibility}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-xs font-semibold tracking-[0.14em] text-gray-400 uppercase">
            Tags
          </span>
          <div className="flex flex-wrap gap-2">
            {doc.tags.map((tag) => (
              <Badge key={tag} label={tag} color="light-gray" size="small" />
            ))}
          </div>
        </div>
        {hasChangelog && (
          <div className="flex flex-col gap-2">
            <span className="text-xs font-semibold tracking-[0.14em] text-gray-400 uppercase">
              Changelog
            </span>
            <ul className="list-disc space-y-1 pl-5 text-sm text-gray-600">
              {doc.changelog.map((entry, index) => (
                <li key={`${entry}-${index}`}>{entry}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Card>
  );
};

export default MetadataPanel;
